import { render, staticRenderFns } from "./ProductPicker.vue?vue&type=template&id=68b13d90&lang=html&"
import script from "./ProductPicker.vue?vue&type=script&lang=js&"
export * from "./ProductPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports